import { useEffect, useState } from 'react'

import { cn } from "@/lib/utils"

/**
 * Wait this long before a skeleton becomes visible. A fetch that resolves
 * faster than this never flashes a gray block — the element stays invisible
 * (but still reserves its layout box, so there's no shift) and then unmounts.
 * Only genuinely slow loads ever show the pulse.
 */
const SKELETON_DELAY_MS = 200

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  const [shown, setShown] = useState(false)

  // setState fires from a timer (async), so it's not a synchronous effect write.
  useEffect(() => {
    const timer = setTimeout(() => setShown(true), SKELETON_DELAY_MS)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div
      data-slot="skeleton"
      // `invisible` keeps the box in layout (fixed-size, no jump) while hidden.
      className={cn("rounded-md bg-accent", shown ? "animate-pulse" : "invisible", className)}
      {...props}
    />
  )
}

export { Skeleton }
